/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function ThreeDModelPreposition(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15594_46539)">
        <path
          d="M8.5 58.1865C3.89789 50.2155 1.59684 46.2299 1.1841 41.8962C1.06398 40.6349 1.06398 39.3651 1.1841 38.1038C1.59684 33.7701 3.89789 29.7845 8.5 21.8135C13.1021 13.8424 15.4032 9.85685 18.9499 7.33256C19.9821 6.59788 21.0818 5.96296 22.2342 5.43635C26.1937 3.62694 30.7958 3.62694 40 3.62694C49.2042 3.62694 53.8063 3.62694 57.7658 5.43635C58.9181 5.96296 60.0179 6.59788 61.0501 7.33255C64.5968 9.85685 66.8979 13.8424 71.5 21.8135C76.1021 29.7845 78.4032 33.7701 78.8159 38.1038C78.936 39.3651 78.936 40.6349 78.8159 41.8962C78.4032 46.2299 76.1021 50.2155 71.5 58.1865C66.8979 66.1576 64.5968 70.1431 61.0501 72.6674C60.0179 73.4021 58.9182 74.037 57.7658 74.5637C53.8063 76.3731 49.2042 76.3731 40 76.3731C30.7958 76.3731 26.1937 76.3731 22.2342 74.5637C21.0818 74.037 19.9821 73.4021 18.9499 72.6674C15.4032 70.1432 13.1021 66.1576 8.5 58.1865Z"
          fill="white"
        />
        <path
          d="M8.5 58.1865C3.89789 50.2155 1.59684 46.2299 1.1841 41.8962C1.06398 40.6349 1.06398 39.3651 1.1841 38.1038C1.59684 33.7701 3.89789 29.7845 8.5 21.8135C13.1021 13.8424 15.4032 9.85685 18.9499 7.33256C19.9821 6.59788 21.0818 5.96296 22.2342 5.43635C26.1937 3.62694 30.7958 3.62694 40 3.62694C49.2042 3.62694 53.8063 3.62694 57.7658 5.43635C58.9181 5.96296 60.0179 6.59788 61.0501 7.33255C64.5968 9.85685 66.8979 13.8424 71.5 21.8135C76.1021 29.7845 78.4032 33.7701 78.8159 38.1038C78.936 39.3651 78.936 40.6349 78.8159 41.8962C78.4032 46.2299 76.1021 50.2155 71.5 58.1865C66.8979 66.1576 64.5968 70.1431 61.0501 72.6674C60.0179 73.4021 58.9182 74.037 57.7658 74.5637C53.8063 76.3731 49.2042 76.3731 40 76.3731C30.7958 76.3731 26.1937 76.3731 22.2342 74.5637C21.0818 74.037 19.9821 73.4021 18.9499 72.6674C15.4032 70.1432 13.1021 66.1576 8.5 58.1865Z"
          fill="url(#paint0_radial_15594_46539)"
          fillOpacity="0.25"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40 27.81L51 33.9216V46.0777L40 52.1879L29 46.0777V33.9216L40 27.81ZM40.873 26.0071C40.6059 25.859 40.3055 25.7812 40 25.7812C39.6945 25.7812 39.3941 25.859 39.127 26.0071L27.927 32.2298C27.6467 32.3854 27.4124 32.6134 27.2495 32.8896C27.0865 33.166 27.0004 33.4809 27 33.8018V46.1945C26.9999 46.5157 27.0858 46.8316 27.2487 47.1084C27.4118 47.3853 27.6459 47.6136 27.927 47.7695L39.1264 53.9905C39.3935 54.1386 39.6945 54.2167 40 54.2167C40.3055 54.2167 40.6059 54.139 40.873 53.9908L52.073 47.7695C52.354 47.6136 52.5882 47.3854 52.7513 47.1084C52.9142 46.8315 53.0001 46.5161 53 46.1949V33.803C52.9996 33.4821 52.9135 33.166 52.7505 32.8896C52.5876 32.6134 52.354 32.3858 52.0737 32.2302L40.873 26.0071Z"
          fill="#141A1F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40 27.81L51 33.9216V46.0777L40 52.1879L29 46.0777V33.9216L40 27.81ZM40.873 26.0071C40.6059 25.859 40.3055 25.7812 40 25.7812C39.6945 25.7812 39.3941 25.859 39.127 26.0071L27.927 32.2298C27.6467 32.3854 27.4124 32.6134 27.2495 32.8896C27.0865 33.166 27.0004 33.4809 27 33.8018V46.1945C26.9999 46.5157 27.0858 46.8316 27.2487 47.1084C27.4118 47.3853 27.6459 47.6136 27.927 47.7695L39.1264 53.9905C39.3935 54.1386 39.6945 54.2167 40 54.2167C40.3055 54.2167 40.6059 54.139 40.873 53.9908L52.073 47.7695C52.354 47.6136 52.5882 47.3854 52.7513 47.1084C52.9142 46.8315 53.0001 46.5161 53 46.1949V33.803C52.9996 33.4821 52.9135 33.166 52.7505 32.8896C52.5876 32.6134 52.354 32.3858 52.0737 32.2302L40.873 26.0071Z"
          fill="url(#paint1_radial_15594_46539)"
          fillOpacity="0.5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.7925 33.2174C27.5243 33.7002 27.6983 34.309 28.1811 34.5772L39 40.5869V51.999C39 52.5513 39.4477 52.999 40 52.999C40.5523 52.999 41 52.5513 41 51.999V40.5877L51.7816 34.5985C52.2644 34.3303 52.4384 33.7215 52.1702 33.2387C51.902 32.7559 51.2932 32.5819 50.8104 32.8501L40.0007 38.8549L29.1523 32.8288C28.6695 32.5606 28.0607 32.7346 27.7925 33.2174Z"
          fill="#141A1F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.7925 33.2174C27.5243 33.7002 27.6983 34.309 28.1811 34.5772L39 40.5869V51.999C39 52.5513 39.4477 52.999 40 52.999C40.5523 52.999 41 52.5513 41 51.999V40.5877L51.7816 34.5985C52.2644 34.3303 52.4384 33.7215 52.1702 33.2387C51.902 32.7559 51.2932 32.5819 50.8104 32.8501L40.0007 38.8549L29.1523 32.8288C28.6695 32.5606 28.0607 32.7346 27.7925 33.2174Z"
          fill="url(#paint2_radial_15594_46539)"
          fillOpacity="0.5"
        />
        <path
          d="M40.412 39.7709L50.812 33.9923C50.9338 33.9247 51.0712 33.8901 51.2104 33.8919C51.3497 33.8938 51.4861 33.9319 51.6061 34.0026C51.7261 34.0733 51.8256 34.1742 51.8947 34.2951C51.9638 34.4161 52.0001 34.553 52 34.6923V46.1949C52.0001 46.3378 51.9619 46.478 51.8894 46.6011C51.817 46.7242 51.7129 46.8256 51.588 46.8949L41.188 52.6723C41.0662 52.7398 40.9288 52.7744 40.7896 52.7726C40.6503 52.7708 40.5139 52.7326 40.3939 52.6619C40.2739 52.5912 40.1744 52.4904 40.1053 52.3694C40.0362 52.2484 39.9999 52.1115 40 51.9723V40.4696C40.0002 40.327 40.0385 40.187 40.1109 40.0642C40.1833 39.9413 40.2873 39.8401 40.412 39.7709Z"
          fill="#141A1F"
        />
        <path
          d="M40.412 39.7709L50.812 33.9923C50.9338 33.9247 51.0712 33.8901 51.2104 33.8919C51.3497 33.8938 51.4861 33.9319 51.6061 34.0026C51.7261 34.0733 51.8256 34.1742 51.8947 34.2951C51.9638 34.4161 52.0001 34.553 52 34.6923V46.1949C52.0001 46.3378 51.9619 46.478 51.8894 46.6011C51.817 46.7242 51.7129 46.8256 51.588 46.8949L41.188 52.6723C41.0662 52.7398 40.9288 52.7744 40.7896 52.7726C40.6503 52.7708 40.5139 52.7326 40.3939 52.6619C40.2739 52.5912 40.1744 52.4904 40.1053 52.3694C40.0362 52.2484 39.9999 52.1115 40 51.9723V40.4696C40.0002 40.327 40.0385 40.187 40.1109 40.0642C40.1833 39.9413 40.2873 39.8401 40.412 39.7709Z"
          fill="url(#paint3_radial_15594_46539)"
          fillOpacity="0.5"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_15594_46539"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(62 26) rotate(141.54) scale(111.743 53.5312)"
        >
          <stop stopColor="#19BCC9" />
          <stop offset="1" stopColor="#E4B6FF" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_15594_46539"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.3131 30.2243) rotate(45.523) scale(57.0377 27.3892)"
        >
          <stop stopColor="#19BCC9" />
          <stop offset="1" stopColor="#E4B6FF" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_15594_46539"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.3131 30.2243) rotate(45.523) scale(57.0377 27.3892)"
        >
          <stop stopColor="#19BCC9" />
          <stop offset="1" stopColor="#E4B6FF" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_15594_46539"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.3131 30.2243) rotate(45.523) scale(57.0377 27.3892)"
        >
          <stop stopColor="#19BCC9" />
          <stop offset="1" stopColor="#E4B6FF" />
        </radialGradient>
        <clipPath id="clip0_15594_46539">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

ThreeDModelPreposition.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default ThreeDModelPreposition
